import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class BcClientListService {

  private apiUrl = globalConst.baseAPI;

  constructor(private http: Http) { }

  getClientList(objToPost, orderby, sort, page, qtd) {
    const skip = qtd * page;
    return this.http
      .post(this.apiUrl + "/collect/v1/customers/?$orderby=" + orderby + " " + sort + "&$top=" + qtd + "&$skip=" + skip, objToPost, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }


  exportClientExcel(listFiltersOBJ) {
    let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
    const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
    return this.http
      .post(this.apiUrl + "collect/v1/customersexcel", listFiltersOBJ, options)
      .map(res => {
        return new Blob([res.blob()], { type: "application/octet-stream" });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-client-list/service/bc-client-list.service.ts